import { useForm } from "@mantine/form";
import { UpdateDeliveryPayroll } from "../../../model/UpdateDeliveryPayroll";
import {
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  MultiSelect,
  NumberInput,
  Select,
  Textarea,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { getDeliveryStatusSelectMdm } from "../../../service/getSelectApi";
import { modals } from "@mantine/modals";
import { IconArrowBackUp, IconCheck } from "@tabler/icons-react";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import {
  repositoryDelivery,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

const EditDataView = ({ data, onClose }: { data: any; onClose: any }) => {
  const entity = {
    asssignmentDetailId: Number(data?.assignmentDetailId),
    distanceEstimated:
      data?.modifiedDistance === null
        ? Number(data?.distanceEstimated) / 1000
        : Number(data?.modifiedDistance) / 1000,
    isPayroll:
      data?.modifiedPayroll === null ? data?.tinhLuong : data?.modifiedPayroll,
    statusId: null,
    note: null,
    parkingFee: 0,
    modifiedWorkId: null,
  };

  const [ParkingFee, setParkingFee] = useState<number>(
    Number(data?.tienGiuiXe) / 1000,
  );

  const [dataTblDeliveryStatusSelect, setDataTblDeliveryStatusSelect] =
    useState<ComboboxItem[]>([]);
  const [dataWorkSelect, setDataWorkSelect] = useState<ComboboxItem[]>([]);

  const form = useForm<UpdateDeliveryPayroll>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {},
  });

  const dataDeliveryStatusSelect = async () => {
    try {
      const getData = await getDeliveryStatusSelectMdm();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblDeliveryStatusSelect(mappedData);
    } catch (error) {
      console.error("Error in dataDeliveryStatusSelect: ", error);
    }
  };

  const dataDeliveryWorkSelect = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmDeliveryWork/get-all",
    );

    const result = res?.success && Array.isArray(res?.data) ? res.data : [];

    setDataWorkSelect(
      result
        // Chỉ lấy công việc áp dụng cho BPGV "NV điều vận" (department = "1")
        .filter(
          (item: any) =>
            item?.name != null &&
            String(item?.department ?? "")
              .split(",")
              .includes("1"),
        )
        .map((item: any) => ({
          value: item?.id?.toString() || "",
          label: item?.name || "",
        })),
    );
  };

  const handleEdit = async (dataSubmit: UpdateDeliveryPayroll) => {
    const res = await repositoryDelivery.post<
      MessageResponse<UpdateDeliveryPayroll>
    >(
      "/api/v1/TblDeliveryAssignment/update-delivery-payroll-for-delivery-manager",
      {
        ...dataSubmit,
        parkingFee: Number(ParkingFee * 1000),
        distanceEstimated: form.getValues().distanceEstimated
          ? Number(form.getValues().distanceEstimated) * 1000
          : 0,
      },
    );

    if (res && res?.success) {
      NotificationExtension.Success("Chỉnh sửa thành công !");
      setTimeout(() => {
        onClose((prev: any) => !prev);
        modals.closeAll();
      }, 1000);
    }
  };

  useEffect(() => {
    dataDeliveryStatusSelect();
    dataDeliveryWorkSelect();
  }, []);

  // Dòng báo cáo chỉ có tên công việc -> đổi sang id để điền sẵn
  useEffect(() => {
    const workName = data?.modifiedDeliveryWorkName ?? data?.deliveryWorkName;
    if (dataWorkSelect.length > 0 && workName) {
      const workIds = String(workName)
        .split(",")
        .map((name) => name.trim().toLowerCase())
        .map(
          (name) =>
            dataWorkSelect.find((item) => item.label.toLowerCase() === name)
              ?.value,
        )
        .filter((id): id is string => !!id);

      if (workIds.length > 0) {
        form.setValues((prev) => ({
          ...prev,
          modifiedWorkId: workIds.join(","),
        }));
      }
    }
  }, [dataWorkSelect]);

  useEffect(() => {
    if (dataTblDeliveryStatusSelect.length > 0) {
      form.setValues((prev) => ({
        ...prev,
        statusId:
          data?.modifiedStatusId !== null
            ? Number(data?.modifiedStatusId)
            : Number(
                getValueById(
                  data?.ttGh?.toString() ?? "",
                  dataTblDeliveryStatusSelect,
                  "value",
                ),
              ),
      }));
    }
  }, [dataTblDeliveryStatusSelect]);

  return (
    <Box
      component="form"
      m={"5px 0px"}
      w={"50vw"}
      maw={700}
      onSubmit={form.onSubmit((e: UpdateDeliveryPayroll) => {
        handleEdit(e);
      })}
      style={{ position: "relative" }}
    >
      <Grid>
        <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
          <Select
            label="Trạng thái đơn GH"
            placeholder="Chọn trạng thái đơn GH"
            value={
              form.getValues()?.statusId
                ? form.getValues()?.statusId?.toString()
                : null
            }
            searchable
            clearable
            data={dataTblDeliveryStatusSelect}
            comboboxProps={{ width: 325 }}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                statusId: e ? Number(e) : null,
              }))
            }
            withAsterisk
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
          <NumberInput
            label="Quãng đường (km)"
            placeholder="Nhập số kilomet"
            value={Number(form.getValues().distanceEstimated)}
            hideControls
            allowNegative={false}
            suffix=" km"
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                distanceEstimated: Number(e),
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
          <NumberInput
            label="Tiền gửi xe"
            placeholder="Nhập tiền gửi xe"
            value={Number(ParkingFee)}
            allowNegative={false}
            onChange={(e) => setParkingFee(Number(e))}
            hideControls
            thousandSeparator=" "
            suffix={ParkingFee === 0 || !ParkingFee ? " VNĐ" : " 000 VNĐ"}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <MultiSelect
            label="Công việc"
            placeholder="Chọn loại công việc"
            clearable
            searchable
            data={dataWorkSelect}
            value={
              form.getValues()?.modifiedWorkId &&
              String(form.getValues()?.modifiedWorkId).length > 0
                ? String(form.getValues()?.modifiedWorkId).split(",")
                : []
            }
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                modifiedWorkId: e ? e.join(",") : "",
              }))
            }
            nothingFoundMessage="Không có dữ liệu !"
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú"
            value={form.getValues().note ?? ""}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                note: e.currentTarget.value,
              }))
            }
          />
        </Grid.Col>
      </Grid>
      <Flex justify="space-between" align="center" mt={5}>
        <Checkbox
          label="Tính lương"
          checked={form.getValues().isPayroll}
          onClick={() =>
            form.setValues((prev) => ({
              ...prev,
              isPayroll: !form.getValues().isPayroll,
            }))
          }
        />
        <Flex align={"center"} gap={"md"}>
          <Button
            type="button"
            color="gray"
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={<IconArrowBackUp size={18} />}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color="teal"
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default EditDataView;
